import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import MasterTheBay from "./sections/MasterTheBay";
import OurCoastalLegacy from "./sections/OurCoastalLegacy";
import DevelopmentSpectrum from "./sections/DevelopmentSpectrum";
import RestorationShowcase from "./sections/RestorationShowcase";
import ServiceRequest from "./sections/ServiceRequest";
export default function HomePage() {
  return <div>
      <Header />
      <MasterTheBay />
      <OurCoastalLegacy />
      <DevelopmentSpectrum />
      <RestorationShowcase />
      <ServiceRequest />
    </div>;
}